<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Device Renewal" title="Safe Custody" />
 
		<div class="container-fluid">
			
			<div class="card">
				<div class="card-body">

                    <div class="col-md-12 project-list filter-sort">
						<div class="row">
							<div class="col-md-4 d-flex">
								<label class="d-flex listing-length"><span>Show</span>
									<select class="form-select" v-model="listing_length" @change="fetchSafeCustodyDevices()">
										<option value="20">20</option>
										<option value="30">30</option>
										<option value="50">50</option>
										<option value="100">100</option>
										<option value="200">200</option>
									</select>
									<span>entries</span>
								</label>
							</div>
							<div class="col-md-2 mt-1">
								<div class="btn btn-info float-end" @click="openModal">Upload</div>
							</div>
							<div class="col-md-2 mt-1">
								<div class="btn btn-light" @click="generateExcel()">Excel</div>
							</div>
							<div class="col-md-2">
								<select class="form-select" v-model="status"  @change="fetchSafeCustodyDevices()">
									<option value="">All</option>
									<option value="2">Completed</option>
									<option value="1">Pending</option>
									<option value="3">Ongoing</option>
								</select>
							</div>
							<div class="col-md-2">
								<input type="text" class="form-control" placeholder="IMEI" v-model="keyword"  @keyup="fetchSafeCustodyDevices()"/>
							</div>
						</div>
					</div>
								
					<div class="table-responsive product-table">
						<table class="display" id="basic-1" >
							<thead>
								<tr align="center">
									<th>IMEI & ICCID</th>
									<th>Expired On</th>
                                    <th>Safe Custody On</th>
                                    <th>Vehicle</th>
									<th>Dealer</th>
									<th>Status</th>
                                    <th>Action</th>
								</tr>
							</thead>

							<tbody v-if="Boolean(safe_custody_devices.length)">
								<tr v-for="(device) in safe_custody_devices" :key="device.id" align="center">
                                    <td>{{ device.imei }} <br>
										{{ device.iccid }}
									</td>
									<td>{{ $filters.formatDateTime(device.expired_on) }}</td>
                                    <td>{{ $filters.formatDate(device.start_date) }}</td>
                                    <td>{{ device.vehicle_no }}</td>
                                    <td>{{ device.dealer }}<br>
										{{ device.dealer_contact }}
									</td>
									<td>
										<span class="badge rounded-pill bg-success" v-if="device.status == 1">Pending</span>
										<span class="badge rounded-pill bg-info" v-if="device.status == 2">Completed</span>
										<span class="badge rounded-pill bg-warning" v-if="device.status == 3">Ongoing</span>
									</td>
                                    <td>
										<router-link :to="{ name: 'recharge_device', params: { device_id: device.device_id } }" class="btn btn-warning btn-sm mt-2 me-2 mb-2" v-if="device.recharge_status != 1">Recharge</router-link>
										<button class="btn btn-danger btn-sm mt-2 me-2 mb-2" type="button" data-original-title="test" @click="deactivateDevice(device)">Deactivate</button>
										<router-link :to="{ name: 'update_vehicle_data',params:{imei:device.imei} }" class="btn btn-primary btn-sm me-2 mb-2" v-if="!device.vehicle_no">Add Vehicle</router-link><br>
										<a class="btn btn-success btn-sm mt-2 me-2 mb-2" @click="renewDevice(device)" v-if="device.renewal_status == 2 && device.recharge_status == 1">Renew</a>
									</td>
								</tr>

							</tbody>
							<tbody v-else>
								<tr>
									<td colspan="12" align="center">No data available</td>
								</tr>
							</tbody>

						</table>
					</div>

					<!----pagination starts --->
					<caption v-if="Boolean(safe_custody_devices.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
					<nav aria-label="Page navigation" class="mt-2 float-end">
						<ul class="pagination">
							<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
								<a class="page-link" href="#" @click.prevent="fetchSafeCustodyDevices(page.url + '&limit=' + listing_length + '&status=' + status  + '&keyword=' + keyword)" tabindex="-1">
									<span v-if="index == 0">Prev</span>
									<span v-else-if="index == pagination.length - 1">Next</span>
									<span v-else>{{ page.label }}</span>
								</a>
							</li>
						</ul>
					</nav>  
					<!----pagination ends --->
                </div>

			</div>

		</div>

		<DynamicModal :title="modal_title">
			<template #body>
				<form @submit.prevent="" enctype="multipart/form-data">
					<div class="row mt-3">
						<div class="col-md-12 form-group">
							<!-- <label class="control-label">Logo </label> -->
							<input class="form-control" type="file" accept=".xls, .xlsx" />
						</div>
					</div>
					
					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" >{{ button_title }}</button>
						<button class="btn btn-light" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

   </div>
</template>


<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "Renewed Devices",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},
		
		data() {

			return {
				modal_title: "Upload Excel",
				button_title: "Upload",

				pagination: {},
				
				keyword: "",
				listing_length: 20,
				token: "",
				status: "",
				safe_custody_devices:[],
                type: "",
                payment_status: "",

				device: 
				{
					id: "",
					user_name: "",
					payment_status: "",
				},
				renew_status: {
					id: "",
				},

				pagination: {},

				complete_status: {
					id: "",
				},
				deactivate_status:{
					imei: "",
				},
				
				errors: {},
				
			};
		},
		mounted() {},

		created() {
			this.fetchSafeCustodyDevices();
		},

		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			fetchSafeCustodyDevices(page_url = null) {
				this.getToken();
				let url = "/staffs/safeCustodyDevices?limit=" + this.listing_length  + "&status=" + this.status + "&keyword=" + this.keyword ;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.safe_custody_devices = responseData.safe_custody_devices.data;
						this.pagination = responseData.safe_custody_devices.links;
						this.from = responseData.safe_custody_devices.from;
						this.to = responseData.safe_custody_devices.to;
						this.total = responseData.safe_custody_devices.total;
						
					})
					.catch((err) => console.log(err));
			},
			

			deactivateDevice(device) {
				this.deactivate = false;
				this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to deactivate this device?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.deactivate_status.imei = device.imei;
						this.sendRequest();
					}
				});
			},

			sendRequest() {
				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};
				this.$axios
					.get("/staffs/deactivateDevice?imei=" + this.deactivate_status.imei , config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.fetchSafeCustodyDevices(this.active_page_url);
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			renewDevice(device) {
				this.deactivate = false;
				this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to renew this device?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.renew_status.id = device.id;
						this.deviceRenew();
					}
				});
			},

			deviceRenew() {
				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};
				this.$axios
					.get("/staffs/renewDevice?device_id=" + this.renew_status.id , config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.fetchSafeCustodyDevices(this.active_page_url);
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			generateExcel() {
				this.getToken();

				let page_url = `/staffs/safeCustodyDeviceReport`;
				this.$axios
					.get(page_url, {
						headers: { Authorization: "Bearer " + this.token },
						responseType: "blob", // Important: expect binary data
					})
					.then((response) => {
						const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
						const link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);
						link.download = `safe_custody_devices_report.xlsx`;
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
					})
					.catch((err) => {
						console.error(err);
						this.$swal("Failed to download report", "", "error");
					});
			},

			openModal() {
				this.showModal();
			},

			closeModal() {
				this.hideModal();
			},
            
			clearForm() {
				this.edit = false;
				this.modal_title = "Upload Excel";
				this.button_title = "Upload";
				this.errors = {};
			},

		},
	};
</script>
